import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { AuthService } from "./auth.service";
import { AbstractHttpService } from "./http-abstract.service";
import { DynamicFormElementDto, NotificationBulkLogDto, BulkNotificationDto, NotificationBulkDto, ResultListDto, CommunicationPlaceholders, NotificationBulkReportDto, NotificationBulkEventsDto, DashboardDto, AgentDto, DashboardRequestDto, DashboardResponseDto } from "./dto";
import { Injectable } from "@angular/core";

@Injectable({
	providedIn: 'root'
})
export class HttpAnalyticsService extends AbstractHttpService {
	constructor(httpClient: HttpClient, authService: AuthService) {
		super(httpClient, '/api/gui/analytics', authService);
	}
	public fetchGuestToken(input: DashboardRequestDto): Observable<DashboardResponseDto> {
		return super.doPost(true, `/guest-token`, input);
	}

	public setFavourite(dashboardId: number): Observable<void> {
		return super.doGet(true, `/${dashboardId}/set-favourite`);
	}

	public getFavourite(): Observable<string> {
		return super.doGetText(true, `/get-favourite`);
	}

	public getAgentsWithMovements(): Observable<AgentDto[]> {
		return super.doGet(true, `/get-agents-with-movements`);
	}

	public getActiveDashboards(pageIndex?: number, pageSize?: number): Observable<ResultListDto<DashboardDto>> {
		return super.doGet(true, `/dashboard/list/active?&pageIndex=${pageIndex ?? 0}&pageSize=${pageSize ?? 20}`);
	}

}
